import { render, staticRenderFns } from "./ElementStudioDefaultProperties.vue?vue&type=template&id=f266aefa&"
import script from "./ElementStudioDefaultProperties.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioDefaultProperties.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStudioDefaultProperties.vue?vue&type=style&index=0&id=f266aefa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports